module.exports = __webpack_public_path__ + "img/icon-seckill.08927de1.png";